import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import { Billing } from "./Billing";
import styles from "./styles/ChoosePlan.module.css";
import Products from "../../Payment/Products";
import ReactGA from "react-ga4";
import { isValidEmail } from "../../../Utils/isValidEmail";
import { useRef } from "react";
import {
  AddSubscription,
  CheckPaymentSubscription,
  RetrieveKey,
  confirmSubscriptionPayment,
  createIbanPaymentMethod,
  createPaymentMethod,
  getStripeCardDetails,
  pendingDiscount,
  showpostalCode,
  updateStripeData,
  validateDiscount,
} from "../../../Utils/StripeUtils";
import PaymentMethodElement from "../../Payment/PaymentMethodElement";
import config from "../../../config";
import { UserData } from "../../../Context/DataContext";
import Loading from "../../Loading/Loading";
import { Payment } from "./Payment";
import { CaretDownOutlined, MenuOutlined } from "@ant-design/icons";
import { PaymentSuccessPage } from "./PaymentSuccessPage";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import { Button, Input, Popover, Form } from "antd";
import { formatTime } from "../../../Utils/formatTime";
import { submitCaptcha } from "../../../Utils/captcha";
import useWindowDimensions from "../../Footer/footer";
import CollapsibleTabs from "./collapseTabs";
import creditCard from "./styles/img/credit-card.svg";
import bankIcon from "./styles/img/bank.svg";
import visa from "./styles/img/Visa.svg";
import americanExpress from "./styles/img/AmericanExpress.svg";
import discover from "./styles/img/Discover.svg";
import masterCard from "./styles/img/MasterCard.svg";
import jcb from "./styles/img/JCB.svg";
import diners from "./styles/img/DinersClub.svg";
import unionPay from "./styles/img/UnionPay.svg";
import directDebit from "./styles/img/direct-debit.svg";
import WelcomePopup from "../Dashboard/WelcomePopup";
import ReferralLoginPopup from "../Dashboard/referralLoginPopup";
import { prepareUserFetch } from "../../../Utils/prepareUserFetch";
const base_url = config.base_url;
function ChoosePlan() {
  const { width } = useWindowDimensions();
  const [ibanForm] = Form.useForm();
  const navigate = useNavigate();
  const [taxes, setTaxes] = useState();
  const websiteCurrentLang = useContext(LanguageContext).language;

  const [content, setContent] = useState(
    websiteCurrentLang.content.User.MyAccount.ChoosePlan
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  function getNavStyles(value) {
    return value === userData.MyAccount
      ? styles.navElementSelected
      : styles.navElement;
  }
  useEffect(() => {
    setContent(websiteCurrentLang.content.User.MyAccount.ChoosePlan);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);

  const userData = UserData();
  const [price, setPrice] = useState(
    userData?.currency?.code?.toUpperCase() ||
      dublicatedcontent?.main_currency?.toUpperCase()
  );

  const [billingData, setBillingData] = useState();
  const [product, setProduct] = useState();
  const [paymentData, setPaymentData] = useState();
  const [card, setCard] = useState();
  const [expandPayment, setExpandPayment] = useState(false);
  const [getNewIntent, setGetNewIntent] = useState(false);
  const [elements, setElements] = useState();
  const [submitLoading, setSubmitLoading] = useState(false);
  const [stripe, setStripe] = useState();
  const [checked, setChecked] = useState(false);
  const wrapperRef = useRef();
  const [currencyMenu, showCurrencyMenu] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [showCouponSection, setShowCouponSection] = useState(true);
  const [coupon, setCoupon] = useState(null);
  const [couponError, setCouponError] = useState(false);
  const [codeAvailableOtherPlan, setCodeAvailableOtherPlan] = useState(false);
  const [couponSuccess, setCouponSuccess] = useState(false);
  const [applybuttonLoading, setApplyButtonLoading] = useState(false);
  const [skeletonLoading, setSkeletonLoading] = useState(false);
  const [modal, setModal] = useState();
  const [countries, setCountries] = useState();
  const [superModal, setSuperModal] = useState();
  const [disableAllExpecptEuro, setDisableAllExpecptEuro] = useState(false);
  const [showIban, setShowIban] = useState(false);
  const [openMenu, setOpenMenu] = useState(1);
  const [priceObj, setPriceObj] = useState({
    subtotal: null,
    subtotal_discounted: null,
    vat: null,
    total: null,
  });
  const [error, setError] = useState({
    product: "",
    billing: "",
    payment: "",
    general: null,
  });

  const [errorForm, setErrorForm] = useState({
    email: "",
    first_name: "",
    last_name: "",
    country: "",
    address: "",
    type: "",
    vat_company_number: "",
  });
  const [userChoseCurrency, setUserChoseCurrency] = useState(false);
  // const notification = UserData()?.BillingData?.status === 'Active';
  const popoverRef = useRef(null);
  const urlParams = new URLSearchParams(window.location.search);

  useEffect(() => {
    const handleScroll = () => {
      if (popoverRef.current && openMenu) {
        const rect = popoverRef.current.getBoundingClientRect();

        const isOutOfView =
          rect.top + 200 < 0 || rect.bottom > window.innerHeight;

        if (isOutOfView) {
          setOpenMenu(openMenu + 1);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [openMenu]);
  useEffect(() => {
    setExpandPayment(card?.card ? false : true);
  }, [card]);
  useEffect(() => {
    pendingDiscount()
      .then((res) => {
        if (res.status == 200) {
          res.json().then((data) => {
            if (!data?.code && urlParams.get("welcome")) {
              setModal(
                <WelcomePopup
                  onClose={() => {
                    userData.setCustomerUser({
                      ...userData.CustomerUser,
                      show_welcome_popup: false,
                    });
                    setModal();
                  }}
                  code={
                    userData.BillingData.plan?.toLowerCase() === "subscribed"
                  }
                ></WelcomePopup>
              );
            } else if (data?.code) {
              const showPopup = JSON.parse(
                localStorage.getItem("showReferralPopup")
              );

              showPopup && setModal(<ReferralLoginPopup couponData={data} />);
              setCoupon(data);
              setCouponCode(data?.code);
            }
          });
        }
      })
      .catch((e) => console.log(e));
  }, []);
  const validateCoupun = async (couponCode) => {
    if (!couponCode) return;

    setApplyButtonLoading(true);
    setSkeletonLoading(true);
    await validateDiscount(couponCode)
      .then((res) => {
        if (res.status !== 200) throw new Error("NoValid");
        else return res.json();
      })
      .then((data) => {
        const { applies_to } = data;
        if (applies_to) {
          if (applies_to.includes(product?.id)) {
            setCouponError(false);
            setCouponSuccess(true);
            setCodeAvailableOtherPlan(false);
            setCoupon(data);
          } else {
            setCoupon(null);
            setCouponSuccess(false);
            setCouponError(false);
            setCodeAvailableOtherPlan(true);
          }
        } else {
          setCouponError(false);
          setCodeAvailableOtherPlan(false);
          setCouponSuccess(true);
          setCoupon(data);
        }
      })
      .catch((e) => {
        setCoupon(null);
        setCouponSuccess(false);
        setCouponError(true);
        setCodeAvailableOtherPlan(false);
      })
      .finally(() => {
        setSkeletonLoading(false);
        setApplyButtonLoading(false);
        setTimeout(() => {
          setCouponSuccess(false);
          setCouponError(false);
          setCodeAvailableOtherPlan(false);
        }, 3000);
      });
  };
  useEffect(() => {
    validateCoupun(couponCode);
  }, [product]);
  const checkBilling = () => {
    let newErrors = {};

    if (billingData.type === "Individual") {
      if (billingData.email === "") {
        newErrors.email = dublicatedcontent.dublicatedText47;
      }
      if (billingData.first_name === "") {
        newErrors.first_name = content.choosePlanError2;
      }
      if (!billingData.last_name || billingData.last_name === "") {
        newErrors.last_name = content.choosePlanError3;
      }

      if (billingData.address === "") {
        newErrors.address = content.choosePlanError4;
      }

      if (billingData.country === "") {
        newErrors.country = content.choosePlanError5;
      }

      if (billingData.email && !isValidEmail(billingData.email)) {
        newErrors.email = dublicatedcontent.dublicatedText47;
      }
      if (
        (!billingData.postal_code || billingData.postal_code === "") &&
        showpostalCode(countries, billingData?.country)
      ) {
        newErrors.postal_code = dublicatedcontent?.fill_postal_code;
      }
    } else if (billingData.type === "Company") {
      if (billingData.email === "") {
        newErrors.email = dublicatedcontent.dublicatedText47;
      }
      if (billingData.first_name === "") {
        newErrors.first_name = content.choosePlanError7;
      }
      if (
        !billingData.vat_company_number ||
        billingData.vat_company_number === ""
      ) {
        newErrors.vat_company_number = content.choosePlanError8;
      }

      if (billingData.address === "") {
        newErrors.address = content.choosePlanError9;
      }

      if (billingData.country === "") {
        newErrors.country = content.choosePlanError10;
      }

      if (billingData.email && !isValidEmail(billingData.email)) {
        newErrors.email = dublicatedcontent.dublicatedText47;
      }
      if (
        (!billingData.postal_code || billingData.postal_code === "") &&
        showpostalCode(countries, billingData?.country)
      ) {
        newErrors.postal_code = dublicatedcontent?.fill_postal_code;
      }
    }

    if (Object.keys(newErrors).length > 0) {
      setErrorForm(newErrors);
      setTimeout(() => {
        Object.keys(newErrors).forEach((key) => {
          setErrorForm((prevError) => ({ ...prevError, [key]: null }));
        });
      }, 5000);
      return true;
    }
  };

  useEffect(() => {
    const tax_decimal =
      taxes?.tax_breakdown?.tax_rate_details?.percentage_decimal / 100;
    if (!coupon) {
      setPriceObj({
        subtotal: (taxes?.amount_total - taxes?.tax_breakdown?.amount) / 100,
        vat: taxes?.tax_breakdown?.amount / 100,
        total: (taxes?.amount_total * 1) / 100,
      });
    } else {
      if (coupon.amount_off) {
        const subtotal =
          (taxes?.amount_total - taxes?.tax_breakdown?.amount) / 100;
        const subtotal_discounted = subtotal - coupon.amount_off;

        const vat = subtotal_discounted * tax_decimal;
        setPriceObj({
          subtotal: taxes?.amount_total / 100,
          subtotal_discounted,
          vat,
          total: vat + subtotal_discounted,
        });
      } else if (coupon.percent_off) {
        const subtotal =
          (taxes?.amount_total - taxes?.tax_breakdown?.amount) / 100;
        const subtotal_discounted = subtotal * (1 - coupon.percent_off / 100);
        const vat = subtotal_discounted * tax_decimal;
        setPriceObj({
          subtotal: taxes?.amount_total / 100,
          subtotal_discounted,
          vat,
          total: vat + subtotal_discounted,
        });
      } else {
        setPriceObj({
          subtotal: taxes?.amount_total / 100,
          vat: taxes?.tax_breakdown?.amount / 100,
          total: (taxes?.amount_total * 1) / 100,
        });
      }
    }
  }, [price, product, coupon, taxes]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getStripeCardDetails()
      .then((res) => {
        return res.json();
      })
      .then((cardData) => {
        setCard(cardData);
      })
      .catch((e) => {
        console.log(e);
        setCard();
      });
  }, []);

  const handleClick = () => {
    if (checkBilling()) {
      return;
    }
    setSubmitLoading(true);
    const name = `${billingData.first_name} ${billingData.last_name}`;
    //If the card exists and the user decides to use the same card (i.e same payment method, we are going to return same method)
    if (card && !expandPayment) {
      setModal(<Loading title={content.choosePlanText1} />);
      return updateStripeData(billingData)
        .then((_) => {
          userData.setBillingData(billingData);
          return CheckPaymentSubscription(product.id, price, couponCode);
        })
        .then((res) => {
          if (res.status !== 200) throw new Error("NotAuthorized");
          return;
        })
        .then((e) => {
          return AddSubscription(product.id);
        })
        .then((res) => {
          if (res.status === 200) {
            userData.getBillingData();
            // return navigate('/user/dashboard', {replace:true})
            res.json().then((data) => {
              localStorage.removeItem("registration_product");
              ReactGA.event("purchase");
              prepareUserFetch(
                () => {
                  return;
                },
                userData,
                () => {
                  return;
                }
              );
              setSuperModal(
                <PaymentSuccessPage
                  plan={
                    product?.metadata[`${websiteCurrentLang?.label}_name`] ||
                    product?.name
                  }
                  user_id={userData.UserData.user_id}
                />
              );
            });
          } else {
            throw new Error();
          }
        })
        .catch((e) => {
          if (e.message === "NotAuthorized") {
            setError({ ...error, general: content.choosePlanError11 });
            setExpandPayment(true);
          } else setError({ ...error, general: content.choosePlanError12 });
        })
        .finally((_) => {
          setModal();
          setSubmitLoading(false);
          setGetNewIntent(!getNewIntent);
          setTimeout(() => {
            setError({ ...error, general: "" });
          }, 5000);
          return;
        });
    }

    createPaymentMethod(
      stripe,
      elements,
      {
        email: billingData.email,
        address: { line1: billingData.address },
        name,
      },
      false
    )
      .then(async (paymentMethod) => {
        setModal(<Loading title={content.choosePlanText1} />);
        const token = await submitCaptcha();
        return fetch(base_url + "user/pay/customer/new", {
          method: "POST",
          mode: "cors",

          headers: {
            Accept: "application/json, text/plain, */*",
            "Content-type": "application/x-www-form-urlencoded",
            credentials: "include",
          },
          credentials: "include",
          body: `token=${token}&email=${billingData.email}&first_name=${billingData.first_name}&last_name=${billingData.last_name}&address=${billingData.address}&vat_company_number=${billingData.vat_company_number}&tax_type=${billingData.tax_type}&plan=${product.id}&paymentMethod=${paymentMethod.paymentMethod.id}&price_id=${product.default_price.id}&type=${billingData.type}&country=${billingData.country}&postal_code=${billingData.postal_code}&currency=${price}&referralCode=${couponCode}`,
        });
      })
      .then(async (res) => {
        if (res.status === 200) {
          AddSubscription(product.id).then((res) => {
            if (res.status === 200) {
              userData.getBillingData();
              res.json().then((data) => {
                localStorage.removeItem("registration_product");
                ReactGA.event("purchase");
                prepareUserFetch(
                  () => {
                    return;
                  },
                  userData,
                  () => {
                    return;
                  }
                );
                setSuperModal(
                  <PaymentSuccessPage
                    plan={
                      product?.metadata[`${websiteCurrentLang?.label}_name`] ||
                      product?.name
                    }
                    user_id={userData.UserData.user_id}
                  />
                );
              });
            } else {
              return Promise.reject(new Error());
            }
          });
        } else if (res.status === 402) {
          const data = await res.json();
          console.log(data);
          return confirmSubscriptionPayment(stripe, data.paymentSecret)
            .then((confirmation) => {
              if (confirmation?.error)
                return Promise.reject(new Error("PaymentDeclined"));
              AddSubscription(product.id)
                .then((res) => {
                  if (res.status === 200) {
                    userData.getBillingData();
                    res.json().then((data) => {
                      localStorage.removeItem("registration_product");
                      prepareUserFetch(
                        () => {
                          return;
                        },
                        userData,
                        () => {
                          return;
                        }
                      );
                      setSuperModal(
                        <PaymentSuccessPage
                          plan={
                            product?.metadata[
                              `${websiteCurrentLang?.label}_name`
                            ] || product?.name
                          }
                          user_id={userData?.UserData?.user_id || undefined}
                        />
                      );
                    });
                  } else {
                    return Promise.reject(new Error());
                  }
                })
                .catch(() => {
                  return Promise.reject(new Error());
                });
            })
            .catch((e) => {
              console.log(e);
              return Promise.reject(new Error(e));
            });
        } else throw new Error(res.status);
      })
      .catch((e) => {
        setModal();
        console.log(e);
        setError({ ...error, general: content.choosePlanError13 });
        setTimeout(() => {
          setError({ ...error, general: "" });
        }, 5000);
        setGetNewIntent(!getNewIntent);
      })
      .finally(() => {
        setSubmitLoading(false);
      });
  };
  const handleClickIBAN = async () => {
    if (checkBilling()) {
      return;
    }

    setSubmitLoading(true);
    let new_stripe = stripe;
    console.log(new_stripe);
    // If the user doesn´t click on "New Credit Card", Stripe won´t load properly
    // This is why I need to load it properly here
    if (!new_stripe) {
      const stripe_key = await RetrieveKey();
      new_stripe = await loadStripe(stripe_key);
    }
    if (card?.sepa_debit) {
      setModal(<Loading title={content.choosePlanText1} />);
      return updateStripeData(billingData)
        .then((_) => {
          userData.setBillingData(billingData);
          return CheckPaymentSubscription(product.id, price, couponCode);
        })
        .then((res) => {
          if (res.status !== 200) throw new Error("NotAuthorized");
          return;
        })
        .then((e) => {
          return AddSubscription(product.id);
        })
        .then((res) => {
          if (res.status === 200) {
            userData.getBillingData();
            // return navigate('/user/dashboard', {replace:true})
            res.json().then((data) => {
              localStorage.removeItem("registration_product");
              ReactGA.event("purchase");
              prepareUserFetch(
                () => {
                  return;
                },
                userData,
                () => {
                  return;
                }
              );
              setSuperModal(
                <PaymentSuccessPage
                  plan={
                    product?.metadata[`${websiteCurrentLang?.label}_name`] ||
                    product?.name
                  }
                  user_id={userData.UserData.user_id}
                />
              );
            });
          } else {
            throw new Error();
          }
        })
        .catch((e) => {
          if (e.message === "NotAuthorized") {
            setError({ ...error, general: content.choosePlanError11 });
            setExpandPayment(true);
          } else setError({ ...error, general: content.choosePlanError12 });
        })
        .finally((_) => {
          setModal();
          setSubmitLoading(false);
          setGetNewIntent(!getNewIntent);
          setTimeout(() => {
            setError({ ...error, general: "" });
          }, 5000);
          return;
        });
    }
    // The following code will only be executed if the users sets a new IBAN number
    const { iban, account_owner_name } = ibanForm.getFieldsValue();
    let payment_method;
    createIbanPaymentMethod(new_stripe, iban, {
      name: account_owner_name,
      email: billingData?.email,
    })
      .then((paymentMethod) => {
        console.log(paymentMethod.paymentMethod.id);
        payment_method = paymentMethod;
        setModal(<Loading title={content.choosePlanText1} />);

        return submitCaptcha().then((token) => {
          const requestBody = new URLSearchParams({
            token,
            email: billingData.email,
            first_name: billingData.first_name,
            last_name: billingData.last_name,
            address: billingData.address,
            vat_company_number: billingData.vat_company_number,
            tax_type: billingData.tax_type,
            plan: product.id,
            paymentMethod: paymentMethod.paymentMethod.id,
            price_id: product.default_price.id,
            type: billingData.type,
            country: billingData.country,
            postal_code: billingData.postal_code,
            currency: "EUR",
            referralCode: couponCode,
          }).toString();

          return fetch(base_url + "user/pay/customer/new", {
            method: "POST",
            mode: "cors",
            headers: {
              Accept: "application/json, text/plain, */*",
              "Content-type": "application/x-www-form-urlencoded",
              credentials: "include",
            },
            credentials: "include",
            body: requestBody,
          });
        });
      })
      .then((res) => {
        if (res.status !== 402) return;
        return res.json().then((resData) => {
          const { paymentSecret } = resData;
          return new_stripe
            .confirmSepaDebitPayment(paymentSecret, {
              payment_method: payment_method.paymentMethod.id,
              setup_future_usage: "off_session",
            })
            .then((confirmRes) => {
              if (confirmRes.error) {
                throw confirmRes;
              }

              return AddSubscription(product.id).then((subscriptionRes) => {
                if (subscriptionRes.status !== 200)
                  return Promise.reject(new Error());

                localStorage.removeItem("registration_product");
                userData.getBillingData();

                return subscriptionRes.json().then((data) => {
                  prepareUserFetch(
                    () => {},
                    userData,
                    () => {}
                  );
                  setSuperModal(
                    <PaymentSuccessPage
                      plan={
                        product?.metadata[
                          `${websiteCurrentLang?.label}_name`
                        ] || product?.name
                      }
                      user_id={userData?.UserData?.user_id || undefined}
                    />
                  );
                });
              });
            });
        });
      })
      .catch((err) => {
        if (err.error.message === "NotAuthorized") {
          setError({ ...error, general: content.choosePlanError11 });
          setExpandPayment(true);
        } else setError({ ...error, general: content.choosePlanError12 });
      })
      .finally((_) => {
        setModal();
        setSubmitLoading(false);
        setGetNewIntent(!getNewIntent);
        setTimeout(() => {
          setError({ ...error, general: "" });
        }, 5000);
        return;
      });
  };

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        showCurrencyMenu(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);
  const creditCardTabImages = [
    {
      src: visa,
      alt: "visa",
    },
    {
      src: masterCard,
      alt: "MasterCard",
    },
    {
      src: discover,
      alt: "Discover",
    },
    {
      src: americanExpress,
      alt: "American Express",
    },

    {
      src: jcb,
      alt: "JCB",
    },
    {
      src: diners,
      alt: "Diners Club",
    },
    {
      src: unionPay,
      alt: "UnionPay",
    },
  ];
  const [openTab, setOpenTab] = useState(null);
  useEffect(() => {
    if (openTab === "iban") {
      setDisableAllExpecptEuro(true);
    } else {
      setDisableAllExpecptEuro(false);
    }
  }, [openTab]);
  const tabs = [
    {
      id: "creditCard",
      title: (
        <>
          <div className={styles.tabButtonContentContainer}>
            <img src={creditCard} alt="credit-card" />
            <p style={{ marginTop: "5px" }}>{dublicatedcontent.credit_card}</p>
          </div>
          <div className={styles.tabButtonContentContainer}>
            {creditCardTabImages.map((image, i) => (
              <img
                key={i}
                src={image.src}
                alt={image.alt}
                style={
                  width > 550
                    ? { height: "35px", width: "35px" }
                    : { height: "30px", width: "30px" }
                }
              />
            ))}
          </div>
        </>
      ),
      content: (
        <>
          {expandPayment ? (
            <PaymentMethodElement
              getNewIntent={getNewIntent}
              onChange={(e) => setPaymentData(e)}
              setStripe={(e) => setStripe(e)}
              setElements={(e) => setElements(e)}
              language={websiteCurrentLang?.label}
            />
          ) : (
            <Payment
              onExpand={() => {
                setExpandPayment(true);
              }}
              expandable={false}
              cardDetails={card}
            />
          )}
          <div className={styles.payment_conditions}>
            <div
              onClick={(e) => {
                setChecked(!checked);
              }}
              className={`${styles.checkbox} ${
                checked ? styles.checked : styles.not_checked
              }`}
            />
            <div className={styles.tos}>
              {dublicatedcontent?.by_checking_this_box_you_agree}{" "}
              <a
                href="/terms-and-conditions"
                target="_blank"
                className={styles.bluetext}
              >
                {dublicatedcontent?.terms_of_service}
              </a>
              ,{" "}
              <a
                href="/privacy-policy"
                target="_blank"
                className={styles.bluetext}
              >
                {dublicatedcontent?.privacy_policy}
              </a>
            </div>
          </div>
          <div className={styles.buttons_div}>
            <Button
              disabled={submitLoading}
              onClick={() => {
                setOpenTab(false);
                setGetNewIntent(!getNewIntent);
              }}
              className={styles.cancelButton}
            >
              {dublicatedcontent?.dublicatedText184}
            </Button>
            <Button
              disabled={!checked || submitLoading}
              onClick={async () => {
                handleClick();
              }}
              className={styles.couponApply}
              style={
                submitLoading
                  ? {
                      width: "130px",
                    }
                  : { width: "fit-content" }
              }
            >
              {dublicatedcontent?.submit}
            </Button>
          </div>
        </>
      ),
    },
    {
      id: "iban",
      title: (
        <>
          <div
            className={styles.tabButtonContentContainer}
            onClick={() => {
              setExpandPayment(true);
            }}
          >
            <img src={bankIcon} alt="bank-icon" />
            <p style={{ marginTop: "5px" }}>
              {dublicatedcontent.instant_bank_transfer}
            </p>
          </div>
          <div className={styles.tabButtonContentContainer}>
            <img src={directDebit} alt={"direct-debit"} />
          </div>
        </>
      ),
      content: (
        <>
          {card?.sepa_debit ? (
            <div>
              <div>
                <Form.Item
                  style={{
                    width: "100%",
                  }}
                  labelCol={{ span: 24 }}
                  name="sepa_iban"
                  label="SEPA IBAN"
                  className={styles.formItemContainer}
                >
                  <div className={styles.sepa_iban_container}>
                    <div className={styles.sepa_iban}>
                      <p
                        style={{
                          color: "black",
                        }}
                      >
                        XXXXXX{card?.sepa_debit?.last4}
                      </p>
                    </div>
                    <Button
                      onClick={() => {
                        setCard({ ...card, sepa_debit: undefined });
                      }}
                      className={styles.couponApply}
                    >
                      {dublicatedcontent?.changeIban}
                    </Button>
                  </div>
                </Form.Item>
              </div>
            </div>
          ) : (
            <Form form={ibanForm}>
              <Form.Item
                style={{
                  width: "50%",
                }}
                labelCol={{ span: 24 }}
                name="account_owner_name"
                label={dublicatedcontent.dublicatedText165}
                rules={[
                  {
                    required: true,
                  },
                ]}
                required
                className={styles.formItemContainer}
              >
                <Input
                  className={styles.iban_input}
                  placeholder={dublicatedcontent.dublicatedText268}
                />
              </Form.Item>
              <Form.Item
                style={{
                  width: "100%",
                }}
                labelCol={{ span: 24 }}
                name="iban"
                label="IBAN"
                rules={[
                  {
                    required: true,
                  },
                ]}
                required
              >
                <Input className={styles.iban_input} placeholder="IBAN" />
              </Form.Item>
            </Form>
          )}
          <div className={styles.payment_conditions}>
            <div
              onClick={(e) => {
                setChecked(!checked);
              }}
              className={`${styles.checkbox} ${
                checked ? styles.checked : styles.not_checked
              }`}
            />
            <div className={styles.tos}>
              {dublicatedcontent?.by_checking_this_box_you_agree}{" "}
              <a
                href="/terms-and-conditions"
                target="_blank"
                className={styles.bluetext}
              >
                {dublicatedcontent?.terms_of_service}
              </a>
              ,{" "}
              <a
                href="/privacy-policy"
                target="_blank"
                className={styles.bluetext}
              >
                {dublicatedcontent?.privacy_policy}
              </a>
            </div>
          </div>
          <div className={styles.buttons_div}>
            <Button
              disabled={submitLoading}
              onClick={() => {
                setOpenTab(false);
              }}
              className={styles.cancelButton}
            >
              {dublicatedcontent?.dublicatedText184}
            </Button>
            <Button
              disabled={!checked || submitLoading}
              onClick={() => {
                console.log("click");
                if (!card?.sepa_debit) ibanForm.submit();
                handleClickIBAN();
              }}
              className={styles.couponApply}
              style={
                submitLoading
                  ? {
                      width: "130px",
                    }
                  : { width: "fit-content" }
              }
            >
              {dublicatedcontent?.submit}
            </Button>
          </div>
        </>
      ),
    },
  ];

  useEffect(() => {
    if (!billingData || !billingData?.currency) return;
    const hasEur = billingData.currency.includes("eur");

    if (hasEur) {
      setShowIban(true);
    } else {
      setShowIban(false);
    }
  }, [billingData]);

  useEffect(() => {
    if (!billingData || !billingData?.currency) return;
    const hasEur = billingData.currency.includes("eur");
    const hasUsd = billingData.currency.includes("usd");
    if (hasEur && !hasUsd) {
      setPrice("EUR");
    }
    if (!hasUsd || !hasEur || userChoseCurrency) return;
    if (localStorage.getItem("language") === "fr") {
      setPrice("EUR");
    } else if (
      localStorage.getItem("language") === "en" &&
      !disableAllExpecptEuro
    ) {
      setPrice("USD");
    }
  }, [websiteCurrentLang, billingData]);
  return superModal ? (
    superModal
  ) : (
    <>
      <div className={styles.headerContainer}>
        <div
          style={
            width < 767
              ? {
                  margin: "0",
                  padding: "0",
                }
              : {}
          }
          className={styles.title}
        >
          {content.choosePlanTitle1}
        </div>
        {width < 767 && (
          <Popover
            key={openMenu}
            style={{
              width: "100%",
            }}
            placement="bottom"
            content={
              <div
                className={styles.popover}
                ref={popoverRef}
                onClick={() => {
                  setOpenMenu(openMenu + 1);
                }}
              >
                <p
                  className={getNavStyles(1)}
                  onClick={() => {
                    userData.setMyAccount(1);
                    navigate("/user/account");
                  }}
                >
                  {dublicatedcontent.dublicatedText77}
                </p>
                <p
                  className={getNavStyles(2)}
                  onClick={() => {
                    userData.setMyAccount(2);
                    navigate("/user/account");
                  }}
                >
                  {dublicatedcontent.dublicatedText246}
                </p>
                <p
                  className={getNavStyles(3)}
                  onClick={() => {
                    userData.setMyAccount(3);
                    navigate("/user/account");
                  }}
                >
                  {dublicatedcontent.dublicatedText245}
                </p>

                {userData?.userValidationData?.status?.toLowerCase() ==
                  "active" &&
                  userData.CustomerUser.user_type?.toLowerCase() ===
                    "partner" && (
                    <p
                      className={getNavStyles(4)}
                      onClick={() => {
                        userData?.userValidationData?.type?.toLowerCase() ===
                        "influencer"
                          ? userData.setMyAccount(6)
                          : userData.setMyAccount(5);
                        navigate("/user/account");
                      }}
                    >
                      {userData?.userValidationData?.type?.toLowerCase() ===
                      "influencer"
                        ? dublicatedcontent?.dublicatedText105
                        : dublicatedcontent?.dublicatedText104}
                    </p>
                  )}
                {userData.CustomerUser.user_type === "Customer" && (
                  <p
                    onClick={() => {
                      userData.setMyAccount(4);
                      navigate("/user/account");
                    }}
                    className={getNavStyles(4)}
                  >
                    {dublicatedcontent.dublicatedText103}
                  </p>
                )}
                {/* <div>
                          {userData.userValidationData.type === "partner" && (
                            <p
                              onClick={() => userData.setMyAccount(5)}
                              className={getNavStyles(5)}
                            >
                              {dublicatedcontent.dublicatedText104}
                            </p>
                          )}
                          {userData.userValidationData.type === "other" && (
                            <p
                              onClick={() => userData.setMyAccount(5)}
                              className={getNavStyles(5)}
                            >
                              {dublicatedcontent.dublicatedText104}
                            </p>
                          )}
                          {userData.userValidationData.type ===
                            "influencer" && (
                            <p
                              onClick={() => userData.setMyAccount(6)}
                              className={getNavStyles(6)}
                            >
                              {dublicatedcontent.dublicatedText105}
                            </p>
                          )}
                        </div> */}
                <p
                  style={{
                    color: "rgba(189, 0, 0, 1)",
                  }}
                  className={styles.navElement}
                  onClick={() => navigate("/logout", { replace: true })}
                >
                  {dublicatedcontent.dublicatedText70}
                </p>
              </div>
            }
            trigger="click"
          >
            {/* <MenuOutlined/> */}
            <div className={styles.navMenuIcon}>
              <MenuOutlined
                style={{
                  fontSize: "20px",
                  cursor: "pointer",
                }}
              />
            </div>
          </Popover>
        )}
      </div>
      {width > 767 && (
        <div
          className={styles.user_id_text}
        >{`${dublicatedcontent.dublicatedText97}: ${userData.UserData.user_id}`}</div>
      )}
      <div className={styles.main}>
        <div className={styles.upper}>
          <div
            className={styles.select_title}
            style={{
              textAlign: "center",
            }}
          >
            {content.choosePlanTitle2}
          </div>
          <div className={styles.plan_header_title}>
            {content.choosePlanText2} <span>{content.choosePlanText3}</span>
            {content.choosePlanText4}
          </div>
          <Products
            subscPlan={userData.BillingData.plan_name}
            currency={price}
            /*
              This page already resolves the coupon -- the pending one from
              signup, or whatever the customer types into the field below -- so
              the cards follow it rather than fetching their own copy.
            */
            coupon={coupon}
            selected={product?.id}
            setSelected={(product) => {
              setProduct(product);
              setBillingData({ ...billingData, plan: product?.id });
            }}
          />
          <div className={styles.error_message}>
            {error.product ? error.product : null}
          </div>
        </div>
        {product && (
          <div className={styles.lower}>
            <div
              className={styles.left}
              onClick={() => {
                if (!product)
                  setError({ ...error, product: "Please select a product" });
                else setError({ ...error, product: null });
              }}
            >
              <Billing
                setCountriesP={(countries) => setCountries(countries)}
                setTaxes={(taxes) => setTaxes(taxes)}
                currency={price.toLowerCase()}
                price_amount={
                  product?.default_price?.currency_options[price?.toLowerCase()]
                    ?.unit_amount_decimal
                }
                postal_code={billingData?.postal_code}
                history={false}
                onChange={(e) => setBillingData(e)}
                disabled={product ? false : true}
                errorForm={errorForm}
                setSkeletonLoading={setSkeletonLoading}
              />
              <div className={styles.error_message}>
                {error.billing ? error.billing : null}
              </div>
            </div>
            <div className={styles.right}>
              {product && taxes && (
                <>
                  <div className={styles.order_summary}>
                    <div className={styles.summary_title}>
                      {content.choosePlanTitle3}
                    </div>
                    <div
                      ref={wrapperRef}
                      onClick={() => showCurrencyMenu(!currencyMenu)}
                      className={styles.select_currency}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        <div>{price}</div>
                        <div className={styles.polygon} />
                      </div>
                      {product && currencyMenu && (
                        <div className={styles.currency_menu}>
                          {billingData?.currency?.map((currency) => {
                            if (disableAllExpecptEuro && currency !== "eur") {
                              return null;
                            }
                            return (
                              <div
                                key={currency}
                                className={styles.currency_option}
                                onClick={(e) => {
                                  setPrice(`${currency.toUpperCase()}`);
                                  setUserChoseCurrency(true);
                                }}
                              >{`${currency.toUpperCase()}`}</div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </div>
                  {/* <Skeleton loading={skeletonLoading} /> */}

                  {/* Coupon code calculations */}
                  {coupon && couponCode && (
                    <>
                      <div className={styles.order_row}>
                        <div className={styles.subtitle1}>
                          {content.choosePlanTitle4}
                        </div>
                        <div
                          className={styles.subtitle1}
                          style={{
                            fontFamily: '"Montserrat", sans-serif',
                          }}
                        >
                          {dublicatedcontent?.price_format
                            ?.replace(
                              "currency_",
                              product?.default_price?.currency_options[
                                price?.toLowerCase()
                              ]?.symbol
                            )
                            ?.replace(
                              "amount_",
                              Math.round(priceObj.subtotal * 100) / 100
                            )}
                        </div>
                      </div>
                      <div className={styles.order_row}>
                        <div className={styles.subtitle2}>
                          Coupon ({couponCode})
                        </div>
                        {/* <div className={styles.subtitle2}>coupon code name</div> */}
                        {coupon.amount_off && (
                          <div
                            className={styles.subtitle2}
                            style={{
                              fontFamily: '"Montserrat", sans-serif',
                            }}
                          >
                            {dublicatedcontent?.price_format
                              ?.replace(
                                "currency_",
                                product?.default_price?.currency_options[
                                  price?.toLowerCase()
                                ]?.symbol
                              )
                              ?.replace("amount_", coupon.amount_off)}
                          </div>
                        )}
                        {coupon.percent_off && (
                          <div className={styles.subtitle2}>
                            {`- ${coupon.percent_off} %`}
                          </div>
                        )}
                        {coupon.time && (
                          <div className={styles.subtitle2}>
                            {`${formatTime(
                              coupon.time,
                              dublicatedcontent,
                              true
                            )?.toLowerCase()} ${
                              dublicatedcontent?.free_subscription
                            }`}
                          </div>
                        )}
                      </div>
                    </>
                  )}

                  {/* {priceObj.subtotal_discounted && (
                    <div className={styles.order_row}>
                      <div className={styles.subtitle1}>
                        {dublicatedcontent?.substotal_after_discount}
                      </div>
                      <div className={styles.subtitle1}>
                        {dublicatedcontent?.price_format
                          ?.replace(
                            "currency_",
                            product?.default_price?.currency_options[
                              price?.toLowerCase()
                            ]?.symbol
                          )
                          ?.replace(
                            "amount_",
                            Math.round(priceObj.subtotal_discounted * 100) / 100
                          )}
                      </div>
                    </div>
                  )} */}
                  <div className={styles.order_row}>
                    <div
                      className={`${styles.subtitle2} ${styles.subtitle2_total}`}
                    >
                      {coupon && couponCode
                        ? content.choosePlanText17
                        : content.choosePlanText5}
                    </div>
                    <div
                      className={`${styles.subtitle2} ${styles.subtitle2_total}`}
                    >
                      {dublicatedcontent?.price_format
                        ?.replace(
                          "currency_",
                          product?.default_price?.currency_options[
                            price?.toLowerCase()
                          ]?.symbol
                        )
                        ?.replace(
                          "amount_",
                          Math.round(priceObj.total * 100) / 100
                        )}
                    </div>
                  </div>
                  {taxes?.tax_breakdown?.amount !== 0 && (
                    <div className={styles.order_row}>
                      <div className={styles.subtitle2}>
                        {dublicatedcontent?.vat || "inc TVA"}{" "}
                        {
                          taxes?.tax_breakdown?.tax_rate_details
                            ?.percentage_decimal
                        }
                        %
                      </div>
                      <div className={styles.subtitle2}>
                        {dublicatedcontent?.price_format
                          ?.replace(
                            "currency_",
                            product?.default_price?.currency_options[
                              price?.toLowerCase()
                            ]?.symbol
                          )
                          ?.replace(
                            "amount_",
                            Math.round(priceObj.vat * 100) / 100
                          )}
                      </div>
                    </div>
                  )}

                  <div
                    onClick={(e) => {
                      setShowCouponSection(!showCouponSection);
                    }}
                    className={styles.couponWrapper}
                  >
                    <p>{content.choosePlanText13}</p>
                    <CaretDownOutlined
                      style={{
                        color: "#0091EA",
                      }}
                    />
                  </div>
                  {showCouponSection && (
                    <div>
                      <div className={styles.couponSection}>
                        <Input
                          onChange={(e) => {
                            setCouponError(false);
                            setCodeAvailableOtherPlan(false);
                            setCouponSuccess(false);
                            setCoupon(null);
                            setCouponCode(e.target.value);
                          }}
                          placeholder={
                            dublicatedcontent?.insert_your_coupon_code
                          }
                          className={styles.couponInput}
                          style={{
                            height: "46px",
                            width: "256px",
                          }}
                        />
                        <Button
                          loading={applybuttonLoading}
                          onClick={(e) => {
                            validateCoupun(couponCode);
                          }}
                          className={styles.couponApply}
                          style={
                            applybuttonLoading
                              ? {
                                  width: "130px",
                                }
                              : { width: "fit-content" }
                          }
                        >
                          {content.choosePlanText14}
                        </Button>
                      </div>
                      {couponError && (
                        <p
                          style={{
                            color: "#FF0000",
                            fontSize: "14px",
                            fontWeight: "500",
                          }}
                        >
                          {content.choosePlanText15}
                        </p>
                      )}
                      {codeAvailableOtherPlan && (
                        <p
                          style={{
                            color: "#FF0000",
                            fontSize: "14px",
                            fontWeight: "500",
                          }}
                        >
                          {dublicatedcontent?.code_not_available_for_this_plan}
                        </p>
                      )}

                      {couponSuccess && (
                        <p
                          style={{
                            color: "#419F23",
                            fontSize: "14px",
                            fontWeight: "500",
                          }}
                        >
                          {content.choosePlanText16}
                        </p>
                      )}
                    </div>
                  )}
                </>
              )}
              <div className={styles.payment_title}>
                <p>{dublicatedcontent.payment_method}</p>
                <div className={styles.pci}></div>
              </div>
              {/* {!expandPayment && (
                <Payment
                  onExpand={() => {
                    setExpandPayment(true);
                  }}
                  expandable={false}
                  cardDetails={card}
                />
              )} */}
              {/* {expandPayment && (
                <PaymentMethodElement
                  getNewIntent={getNewIntent}
                  onChange={(e) => setPaymentData(e)}
                  setStripe={(e) => setStripe(e)}
                  setElements={(e) => setElements(e)}
                  language={websiteCurrentLang?.label}
                />
              )} */}
              <CollapsibleTabs
                tabs={showIban ? tabs : tabs.filter((tab) => tab.id !== "iban")}
                setOpenTab={setOpenTab}
                openTab={openTab}
                onClickIbanFunc={() => {
                  setPrice("EUR");
                  setDisableAllExpecptEuro(true);
                }}
              />
              {/* <div className={styles.payment_conditions}>
                <div
                  onClick={(e) => {
                    setChecked(!checked);
                  }}
                  className={`${styles.checkbox} ${
                    checked ? styles.checked : styles.not_checked
                  }`}
                />
                <div className={styles.tos}>
                  {dublicatedcontent?.by_checking_this_box_you_agree}{" "}
                  <a
                    href="/terms-and-conditions"
                    target="_blank"
                    className={styles.bluetext}
                  >
                    {dublicatedcontent?.terms_of_service}
                  </a>
                  ,{" "}
                  <a
                    href="/privacy-policy"
                    target="_blank"
                    className={styles.bluetext}
                  >
                    {dublicatedcontent?.privacy_policy}
                  </a>
                </div>
              </div>

              <div className={styles.buttons_div}>
                <Button
                  disabled={!checked || submitLoading}
                  onClick={async () => {
                    handleClick();
                  }}
                  className={styles.couponApply}
                  style={
                    submitLoading
                      ? {
                          width: "130px",
                        }
                      : { width: "fit-content" }
                  }
                >
                  {dublicatedcontent?.submit}
                </Button>
              </div> */}
              <div
                className={styles.error_message}
                style={{ textAlign: "left" }}
              >
                {error.general}
              </div>
            </div>
          </div>
        )}

        {modal}
        {/* {notification &&
                    <PaymentSuccess OnClose={() => navigate('/user/account', {replace:true})} title={'You already have a plan'} subtitle={'Contact support to upgrade plan'} />
                } */}
      </div>
    </>
  );
}
export { ChoosePlan };
